import { InputBase, InputTypeaheadController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

import { Objects } from "@salaxy/core";

// TODO: commenting
/**
 * Select component for typeahead.
 * @example
 * ```html
 * <salaxy-input-typeahead name="CompanyType" label="Company" hidden-options="unknown"></salaxy-input-typeahead>
 * ```
 */
export class InputTypeahead extends ComponentBase {

  /** ng-model is required, form tag is optionally used for validation and disabled/readonly */
  public require = {
    model: "ngModel",
    form: "?^^form",
  };

  /**
   * The following component properties (attributes in HTML) are bound to the Controller.
   * For detailed functionality, refer to [controller](#controller) implementation.
   */
  public bindings = Objects.extend(InputBase.crudBindings, {
    /**
     * Binds to an enumeration defined by the Salaxy API.
     * Set the name of the enumeration.
     */
    enum: "@",

    /**
     * Options of the select control as a key-value object.
     */
    options: "<",

    /**
     * Array or comma separated string to filter the option values to just the given ones.
     * Also sets the order to this order, so works for ordering a given set of values.
     * Note that hiddenOptions is applied first, so if you want e.g. "undefined" to appear if selected,
     * you may add it here and it behaves as expected (undefined is still hidden if a value is selevted).
     */
    filter: "@",

    /** If true, the control is not caching values. */
    disableCache: "@",

    /**
     * Label format for the option. The default format is to show only the text of the option.
     * Options are:
     * "text" or empty: only the text of the option is displayed.
     * "text-value": in addition to the text, the value is also displayed in the label.
     * "value": only the value is displayed.
     */
    labelFormat: "@",

    /** If true, upon selection the value is not set for the input field (it is used for other things thought). */
    clearOnSelect: "<",

    /** If true, save new values (ones typed but not found in the select list) to database. Used in ng1-aspa. */
    allowCustomValues: "<",

    /** True = return the typeahead selection object alongside the value. */
    returnObject: "<",

    /** The object data that's to be returned. */
    objectData: "=",

    /** True = The value is saved as a whole object, false = as a primitive (string/number/etc. from the item key "value") */
    valueAsObject: "<",

    /** Text if the input field must have a placeholder text. */
    placeholder: "@"
  });

  /** Uses the InputTypeaheadController */
  public controller = InputTypeaheadController;

  /** The default template for the component. */
  public defaultTemplate = "salaxy-components/form-controls/InputTypeahead.html";
}
